
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
clear () {
this.p_name_h = ''
this.p_name_c = ''
},
doSearchHS () {
this.$router.push({path: '/CiqSearchListByHS', query: { p_name: this.p_name_h }})
},
doSearchCIQ () {
this.$router.push({path: '/CiqSearchListByCode', query: { p_name: this.p_name_c }})
}
},
data () {
return {
queryResult: {Data: [], TotalPage: 0},
p_code: '',
p_name_h: '',
p_name_c: '',
desc: null,
currentPage: 1
}
},
async activated () {
}
}



// WEBPACK FOOTER //
// ./src/components/CiqSearch.vue